import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Country } from '../models/common/countries.model';

@Injectable({ providedIn: 'root' })
export class CommonServices {

    private readonly apiUrl = `${environment.apiUrl}`;

    readonly companiesTypes = signal<string[]>([]);
    readonly countries = signal<Country[]>([]);

    constructor(private http: HttpClient) { }

    getCompaniesTypes(): Observable<string[]> {
        return this.http.get<string[]>(`${this.apiUrl}corporate/company-types`);
    }

    getCountries(): Observable<Country[]> {
        return this.http.get<Country[]>(`${this.apiUrl}utils/countries`);
    }

    loadCompaniesTypes() {
        this.getCompaniesTypes().subscribe({
            next: (data) => {
                this.companiesTypes.set(data);
            },
            error: (error) => {
                console.error('Error loading companies types:', error);
            }
        });
    }

    loadCountries() {
        this.getCountries().subscribe({
            next: (data) => {
                this.countries.set(data);
            },
            error: (error) => {
                console.error('Error loading countries:', error);
            }
        });
    }

}